import { call, put, takeEvery } from 'redux-saga/effects'
import {
  //getScanCenter
  getScanCenterList,
  getScanCenterDataSuccess,
  getScanCenterDataFailed,
} from './slice'
import { API } from 'src/main/services'

function* getScanCenter({ type, payload }) {
  try {
    const response = yield call(API.providerManagement.getScanCenterData, payload)
    if (response.data && response.status === 200) {
      yield put(getScanCenterDataSuccess({ payload: response?.data }))
    } else {
      yield put(getScanCenterDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getScanCenterDataFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(getScanCenterList, getScanCenter)
}

export default authSaga
